import { Box, Typography, useTheme } from "@mui/material";
import {
  BasicSwitch,
  normalizeStructureData,
  resolveStructureData,
  ShowToastSuccess,
  SlugField,
  TitleSubTitle,
} from "@platformx/utilities";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import StructureData from "../StructureData/StructureData";
import { useStyles } from "./Seo.styles";

interface SlugFieldConfig {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  canonicalUrl?: string;
}

const Seo = ({
  state,
  setState,
  updateStructureDataArticle,
  slugField,
}: {
  state: any;
  setState: any;
  updateStructureDataArticle: any;
  slugField?: SlugFieldConfig;
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const [openSD, setOpenSD] = useState<boolean>(false);
  const openStructureData = () => {
    setOpenSD(!openSD);
  };
  // Envelope { use, auto, manual } — legacy plain JSON-LD and empty state normalize into auto.
  const storedEnvelope = normalizeStructureData(state?.CommonFields?.structure_data);
  const envelope =
    Object.keys(storedEnvelope.auto).length !== 0
      ? storedEnvelope
      : { ...storedEnvelope, auto: updateStructureDataArticle() };
  const overrideMarkup = envelope.use === "manual";

  // Toggle persists as the envelope's `use`; manual seeds from auto once and is retained.
  const handleOverrideMarkupChange = (event) => {
    const { checked } = event.target;
    const next = {
      ...envelope,
      manual: checked && !envelope.manual ? { ...envelope.auto } : envelope.manual,
      use: checked ? "manual" : "auto",
    };
    setState({
      ...state,
      CommonFields: {
        ...state.CommonFields,
        structure_data: JSON.stringify(next),
      },
    });
  };

  const copyStructureData = (structureData = resolveStructureData(envelope)) => {
    navigator.clipboard.writeText(JSON.stringify(structureData, undefined, 2));
    ShowToastSuccess(`${t("page_structure_data")} ${t("copied")}`);
  };
  const handleSeoChange = () => {
    setState({
      ...state,
      CommonFields: {
        ...state.CommonFields,
        seo_enable: !state?.CommonFields?.seo_enable,
      },
    });
  };
  return (
    <>
      <Box className={classes.container}>
        <Box className={classes.width40}>
          <TitleSubTitle
            title={t("page_prelem_find")}
            subTitle={t("seo_description")}
            titleVariant='h6medium'
            subTitleVariant='p4regular'
          />
        </Box>
        <Box className={classes.width60}>
          <BasicSwitch
            onChange={handleSeoChange}
            checked={state?.CommonFields?.seo_enable}
            // disabled={isDisable}
            color={theme.palette.customColor.PRIMARY}
          />
        </Box>
      </Box>

      {slugField && (
        <Box sx={{ marginBottom: "40px" }}>
          <SlugField
            value={slugField.value}
            onChange={slugField.onChange}
            onBlur={slugField.onBlur}
            canonicalUrl={slugField.canonicalUrl}
          />
        </Box>
      )}

      {/* <Box className={classes.container}>
        <Box className={classes.width40}>
          <TitleSubTitle
            title={t('page_prelem_share')}
            subTitle={t('quiz_ss_subtitle')}
            titleVarient='h6medium'
            subTitleVarient='h7regular'
          />
        </Box>
        <Box className={classes.width60}>
          <BasicSwitch
            onChange={() =>
              setSeoState({ ...seoState, share: !seoState.share })
            }
            checked={seoState.share}
            // disabled={isDisable}
            color={theme.palette.customColor.PRIMARY}
          />
        </Box>
      </Box> */}
      <Box className={classes.sdContainer}>
        <Box className={classes.width40}>
          <TitleSubTitle
            title={t("page_structure_data")}
            subTitle={t("click_to_sd")}
            titleVariant='h6medium'
            subTitleVariant='p4regular'
          />
        </Box>
        <Box className={classes.flexBox}>
          <Typography
            variant='h6medium'
            data-testid='structuredata'
            className={classes.typo}
            onClick={() => openStructureData()}>
            <u>{t("see_sd")}</u>
          </Typography>
          <Box className={classes.typoDivider}></Box>
          <Typography
            variant='h6medium'
            data-testid='copycode'
            className={classes.typo}
            onClick={() => copyStructureData()}>
            {t("copy_sd")}
          </Typography>
        </Box>
      </Box>
      {openSD && (
        <StructureData
          state={state}
          setState={setState}
          structureDataEnvelope={envelope}
          openStructureData={openStructureData}
          copyStructureData={copyStructureData}
          overrideMarkup={overrideMarkup}
          onOverrideMarkupChange={handleOverrideMarkupChange}
        />
      )}
    </>
  );
};

export default Seo;
